export default {
  id: 'completed-User',
  navTitleID: 'completed-User.navTitle',
  pages: [
    {
      id: 'page-1',
      components: [
        {
          type: 'text',
          titleID: 'title',
          textLayout: 'inverse',
          textID: 'text'
        }
      ]
    }
  ]
}
